'use strict';

function NoVideoInputDevicesError() {
  this.name = 'NoVideoInputDevicesError';
  this.message = 'No video input devices found';
}
NoVideoInputDevicesError.prototype = new Error();

module.exports = {
  NoVideoInputDevicesError: NoVideoInputDevicesError
};


//////////////////
// WEBPACK FOOTER
// ./~/react-qr-reader/lib/errors.js
// module id = 845
// module chunks = 0